export const ACCOUNT_SUBDOMAIN_TEXT = {
    id: 'oe.accountAdmin.accountSubdomain',
    defaultMessage: 'Account Subdomain',
    description: 'Label text'
};

export const ACCOUNT_SUBDOMAIN_MANDATORY_TEXT = {
    id: 'oe.accountAdmin.accountSubdomainRequired',
    defaultMessage: 'Account Subdomain is required',
    description: 'Label text'
};

export const ACCOUNT_SUBDOMAIN_STATUS_TEXT = {
    id: `oe.accountAdmin.accountSubdomainStatus`,
    defaultMessage: 'Account Subdomain is {suffix}',
    description: 'Account Subdomain status text'
};

export const ACCOUNT_SUBDOMAIN_EXPLANATORY_TEXT = {
    id: `oe.accountAdmin.accountSubdomainStatusExplanatoryText`,
    message: 'Account Subdomain is a paid for feature. Please contact Engineering to implement Account Subdomain before enabling or disabling this toggle.',
    description: 'Account Subdomain explanatory text'
};

export const ACCOUNT_SUBDOMAIN_STATUS_UPDATED_TEXT = {
    id: 'oe.accountAdmin.accountSubdomainStatusUpdated',
    description: 'Notification text',
    defaultMessage: 'Account Subdomain Data updated'
};